<template>
  <modal name="problem-container"
         :classes="['v--modal']"
         transition="nice-modal-fade"
         :adaptive="true"
         :pivot-y="0.5"
         height="auto"
         :scrollable="true">
    <problem-editor 
      :problem="problem"
      :fulledit="fulledit"
      :edit="edit"
      :create="create"
      :profile="profile"
      @cancel="problemEditorCanceled" 
      @created="problemEditorCreated" 
      @updated="problemEditorUpdated" />
  </modal>
</template>

<script>
  import ProblemEditor from '@/components/ProblemEditor.vue'
  export default {
    name: 'ProblemEditorModal',
    components: {
      ProblemEditor
    },
    props: {
      problem: {
        type: Object
      },
      fulledit: {
        type: Boolean
      },
      edit: {
        type: Boolean,
        default: false
      },
      create: {
        type: Boolean,
        default: false
      },
      profile: {
        type: Object
      }
    },
    methods: {
      problemEditorCanceled () {
        this.$emit('cancel')
      },
      problemEditorCreated (saved) {
        this.$emit('created', saved)
      },
      problemEditorUpdated (saved) {
        this.$emit('updated', saved)
      }
    },
  }
</script>

<style scoped>

</style>